@import "~@swisscom/sdx/stylesheets/sdx/variables/colors";
@import "~@swisscom/sdx/stylesheets/sdx/variables/sizes";
@import "~@swisscom/sdx/stylesheets/sdx/variables/grid";
@import "~@swisscom/sdx/stylesheets/sdx/mixins/breakpoints";
@import "~@swisscom/sdx/stylesheets/sdx/mixins/mediaqueries";
@import "~@swisscom/sdx/stylesheets/sdx/mixins/typography";
@import "~@swisscom/sdx/stylesheets/sdx/mixins/text";
@import "~@swisscom/sdx/stylesheets/sdx/mixins/misc";
@import "~@swisscom/sdx/stylesheets/sdx/mixins/core";
@import "~@swisscom/sdx/stylesheets/sdx/mixins/button";
@import "~@swisscom/sdx/stylesheets/sdx/variables/global";
@import "~@swisscom/sdx/stylesheets/sdx/button/button";
@import "~@swisscom/sdx/stylesheets/sdx/link/link";
@import "~@swisscom/sdx/stylesheets/sdx/typography/typography";

.cards {
  // ul reset
  list-style: none;
  padding: 0;
  margin: 0;
}

.trailing-spacer {
  height: 352px;
}

.card-container {
  display: flex;
  flex-direction: column;
  position: relative;
}

.card-image-container {
  position: absolute;
  top: 0;
  width: 100%;
  height: 256px;
  border-radius: 20px;
  opacity: 0; // start hidden until scene enters
  transition: opacity 200ms ease;
  padding: 64px 0 32px;
  background: linear-gradient(
    180deg,
    #ffffff 0%,
    rgba(255, 255, 255, 1) 95%,
    rgba(255, 255, 255, 0.9) 96%,
    rgba(255, 255, 255, 0.85) 98%,
    rgba(255, 255, 255, 0.7) 100%
  );
  z-index: 1;

  &.visible {
    opacity: 1 !important;
  }

  &.fade-out {
    opacity: 0;
  }
}

.card-image {
  width: 100%;
  height: 256px;
  border-radius: 20px;
  object-fit: cover;
  object-position: center;
}

.card-title {
  margin-bottom: 16px;
}

.card-description {
  margin-bottom: 16px;
}

.card-text-content {
  display: flex;
  flex-direction: column;
  padding: 364px 32px 0;
  opacity: 0.7;
  transition: opacity 200ms ease;
}

.active .card-text-content {
  opacity: 1;
}

@media (min-width: 768px) {
  .card-container {
    display: flex;
    flex-direction: row;
    height: 500px;
    position: unset;
  }

  .card-image-container {
    position: unset;
    top: unset;
    padding: unset;
    background: unset;
  }

  .card-image {
    width: 100%;
    height: 108%;
    border-radius: 20px;
    object-fit: cover;
    object-position: center;
  }

  .card-text-content {
    display: flex;
    width: 50%;
    padding: 200px 32px 100px;
    flex-direction: column;
    justify-content: center;
    min-width: 300px;
  }

  .trailing-spacer {
    height: 76px;
  }
}

@media (min-width: 1024px) {
  .card-image {
    height: 139%;
  }

  .trailing-spacer {
    height: 156px;
  }
}

@media (min-width: 1280px) {
  .card-image {
    height: 176%;
  }

  .trailing-spacer {
    height: 251px;
  }
}
